/* This file is autogenerated, see readme.md for instructions */
import ShareSvgIcon from '@bloomreach/banana-theme/icons/share.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const ShareIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <ShareSvgIcon />
    </Icon>
  );
});

ShareIcon.displayName = 'ShareIcon';

export default ShareIcon;
